import './App.css';
import { AppRouter } from './app/AppRouter';
import { BackgroundProvider } from './contexts/BackgroundContext';
import { ThemeProvider } from './contexts/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <BackgroundProvider>
        <AppRouter />
      </BackgroundProvider>
    </ThemeProvider>
  );
}

export default App;
